import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import { BackButton, ClearFilterButton, CreateButton, EditButton, ExportButton, FilterButton, ImportButton } from '../../../../Components/Utils/Buttons';
import { GetAccess } from '../../../../Components/Utils/roles';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';

const ScheduleLayout = (  {
    getData=() => {},
    setSearchQuery=()=>{},
    CreateAccess= false,
    ImportAccess= false,
    BackAccess=false,
    EditAccess=false,
    setOpen=()=>{},
    setOpenExport=()=>{},
    children,
    onCreateClick,
    searchValue="",
    searchFun=()=>{},
    isFilter=false,
    setFilterOpen=()=>{},
    newfilter=false,
    ClearFilter=()=>{},
    neededSearch=false,
    showproject=true,
    isCard=true,
    setViewMode=()=>{},
        viewMode="",
        ExportAccess=false
        

})  => {
    let {pathname} = useLocation()
    const [module,setModule] = useState("")
    const navigate = useNavigate();
     const { clientViewId,scheduleViewId } = useParams();
    
            const location = useLocation();
              const data = location.state?.data;
              const pageIndex = location.state?.pageIndex;
              const searchQuery = location.state?.searchQuery;
              const fromDashboard = location.state?.fromDashboard === true;
      
      
      let searchList = [
          { value: "all", label: "All" },
          { value: "services", label: "Services" },
          { value: "products", label: "Products" },
        ];
  
          const [screenSize, setScreenSize] = useState({
            width: window.innerWidth,
          });
        
          useEffect(() => {
            const handleResize = () => {
              setScreenSize({
                width: window.innerWidth,
              });
            };
        
            window.addEventListener("resize", handleResize);
        
            return () => {
              window.removeEventListener("resize", handleResize);
            };
          }, []);
    
    useEffect(() =>{
        if(pathname == `/Contract-management/schedules/view/${scheduleViewId}`){
            setModule("Details")

        }else if(pathname == `/Contract-management/schedules/forms/${scheduleViewId}`){
            setModule("Forms")
        }
    },[pathname])
  
    let LinkItem = [
        {
            label:"Details",
            link:`/Contract-management/schedules/view/${scheduleViewId}`,
            access:true,
            
        },
        {
  
            label:"Schedule Form",
  
            link:`/Contract-management/schedules/forms/${scheduleViewId}`,
            access:GetAccess('commissioning_schedules_form_view'),
        },
        // {
        //   label:"Cont. Equipments",           
        //     link:`/client-management/equiments`,
        //     access:GetAccess(),
        // },
       
       
    ];
  
    const handleCreateClick = () => {
      if (module === "Cont. Equipt.") {
          onCreateClick && onCreateClick(); 
      } else {
        navigate(`${pathname}/create`);
      }
    };
  
  
  
    return(
      <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
              
        <div className="md:flex justify-between w-full ">
        <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {
                      name: "Schedules",
                      link:"/Contract-management/schedules"

                     
                    },
        
                    { name: module },
                  ]}
                />
<div className="flex gap-2 justify-end">
{newfilter && (
    <>
                <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
                {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} </>)}
<div className=" flex justify-end items-center gap-3 ">
          <div className=" flex gap-2">
            {/* <Link
              to={`/Contract-management/schedules`}
              state={{
                currentPage: pageIndex,
                searchQuery: searchQuery != "" ? searchQuery : "",
              }}
            >
              <BackButton link={true} />
            </Link> */}

            <BackButton
                link={true}
                hasLink={
                  fromDashboard
                    ? "/dashboard"
                    : module !== "Details"
                    ? `/Contract-management/schedules`
                    : `/Contract-management/schedules`
                }
                state={
                  !fromDashboard && module === "Details"
                    ? {
                        currentPage: pageIndex,
                        searchQuery: searchQuery !== "" ? searchQuery : "",
                      }
                    : null
                }
              />

              {/* <BackButton
                                                  link={true}
                                                  hasLink={
                                                    module !== "Details"
                                                      ? `/Contract-management/schedules/view/${scheduleViewId}`
                                                      : `/Contract-management/schedules`
                                                  }
                                                  state={
                                                    module === "Details"
                                                      ? {
                                                          currentPage: pageIndex,
                                                          searchQuery: searchQuery !== "" ? searchQuery : "",
                                                        }
                                                      : null
                                                  }
                                                /> */}
            {EditAccess && (
              <Link
                to={`/Contract-management/schedules/edit/${scheduleViewId}`}
                state={{
                  data: data,
                  from: `/Contract-management/schedules/view/${scheduleViewId}`,
                }}
              >
                <EditButton height="8" />
              </Link>
            )}
          </div>
        </div>
        </div>


      </div>
             
  
  <div className=" w-full  flex items-center gap-x-1 ">
              {
                  LinkItem && LinkItem.map((item, i) => {
                    const isActive = item?.link === pathname;
                      return(
                          <>
                           {
                              item.access && (
                                                      <Link   to={item?.link}
                                                      key={item?.link}
                                                                                                    state={{fromDashboard:fromDashboard}}

                                                      className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                        ${isActive 
                                                          ? "bg-baseColor-primary text-white" 
                                                          : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                        }`}
                                                    >
                                                      {item?.label || ""}</Link>
                                       )
                           }
                          </>
                      )
                  })
              }
          </div>
  
  
  
              
              
             
             
             
              <div className=" w-full h-[calc(100vh-165px)]  ">
                 {children} 
              </div>
              </div>
         
  )
}

export default ScheduleLayout
